import { AuthActionCreators, IGet } from '@nkr/store/authorization';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { useEffect, useState } from 'react';

export interface INetworkEmailLogDetail {
    id: number;
    sentDate: string | null;
    sender: string;
    subject: string;
    message: string;
    centerNames: string[];
    courierNames: string[];
    positionNames: string[];
    additionalRecipients: string[];
}

interface IRetVal {
    data: INetworkEmailLogDetail | null;
    loading: boolean;
    error: string;
}

const useNetworkEmailLogDetail = (id: number | null, centerId?: number): IRetVal => {
    const { dispatch } = useAppHookContext();
    const [data, setData] = useState<INetworkEmailLogDetail | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        if (!id) {
            setData(null);
            return;
        }

        setLoading(true);
        setError('');

        const fetchData = async () => {
            const params = new URLSearchParams();

            if (centerId) {
                params.append('centerId', String(centerId));
            }

            const config: IGet = { url: `${__API__}/email/network/log/${id}?${params.toString()}` };

            try {
                const response = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.success) {
                    setData(response.data.results);
                } else {
                    setError('Unable to load email details');
                }
            } catch (err) {
                setError(err?.message ?? 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id, centerId]);

    return { data, loading, error };
};

export default useNetworkEmailLogDetail;
